var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-detail"},[_c('ProjectTop',{attrs:{"register":_vm.projectAttend,"type":2}}),(_vm.headerInfo.package_type == 1 && (_vm.special.length || _vm.file.length))?_c('Special',{attrs:{"special":_vm.special,"file":_vm.file}}):_vm._e(),_c('ProjectTab',{attrs:{"showTabItem":_vm.showTabItem,"type":2}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }